export default {
  init() {
    $(document).ready(function() {

      $('.navbar-burger').click(function() {
      
          $('.navbar-burger').toggleClass('is-active');
          $('#navMenu').toggleClass('is-active');
      
      });
    });
    $('.dropdown-counter').click(function(){
      $('.icon-dropdown', this).slideToggle(200);
    });
    $( document ).ready(function() {
        $('.icon-dropdown').toggle();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
